import * as UsersActions from 'client/features/users/actions'
import _ from 'underscore'

const initialState = {
    all: [],
    current: null
}

const initializeState = () => Object.assign({}, initialState)

export default function reports(state = initializeState(), action = {}) {
    switch (action.type) {

    case UsersActions.UsersRequest.get.TYPES.SUCCESS:
        return { ...state, all: action.payload.users }

    case UsersActions.SET_CURRENT_USER:
        return { ...state, current: action._id }

    default: 
        return state
    }
}


// WEBPACK FOOTER //
// ./src/client/features/users/reducers.js